import React, { Component } from "react";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";

import Sidebar from "../components/Sidebar";
import { withSidebar } from "../context/SidebarContext";
import axios from "axios";
import { saveAs } from "file-saver";
import moment from "moment";
import { makeLicensePayment } from "../Helper/paymentHelper";
import {
  checkLicenseRenewalNeeded,
  translateLicenseStatusCode,
} from "../Helper/utils";

// Dashboard Components
import {
  DashboardHeader,
  StatusBanner,
  StatCard,
  QuickActions,
  LicenseTimeline
} from "../components/dashboard";
import "../assets/css/dashboard.css";

const baseUrl = process.env.REACT_APP_BASE_URL;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      allPayments: [],
      license: [],
      isLicenseLoading: true,
      isAllPaymentsLoading: true,
      isUserInfoLoading: false,
      isDownloading: false,
      fullName: "",
      regNumber: "",
      regOfficialRemarks: "",
      userMail: "",
      applicationDate: "",
      registrationDate: "",
      practiceCategory: "",
      address: "",
      orgName: "",
      orgNamePractice: "",
      leadScientist: "",
      image: "",
      regCert: "",
      licenseCert: "",
      licenseData: null,
      recId: "",
      regCertificateFile: "",
      licenseCertificateFile: "",
      licenseStatus: "",
      regStatus: "",
      certificateIssued: false,
      hasRegistrationCertificate: false,
      hasLicenseApplication: false,
      paymentStatus: false,
      expired: "",
      showRenewalNotification: false,
      retrievedLicenseInfo: {
        licenseId: null,
        rrr: null,
      },
      isVerifyingPayments: false,
    };

    // Status codes that indicate payment is complete - no need to re-check
    this.COMPLETE_CODES = ['complete', '00', 'waived', 'successful'];

    this.getLicenseDetails = this.getLicenseDetails.bind(this);
    this.translateLicenseStatusCode = translateLicenseStatusCode.bind(this);
  }

  getLicenseNumber = async () => {
    let obj = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await fetch(
      `${baseUrl}/License/getlicenseByUserID/${localStorage.getItem("userid")}`,
      obj
    )
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status === 401) {
          this.setState({ isLicenseLoading: false });
          Swal.fire({
            title: "Session Expired",
            text: "Session expired. Please login",
            icon: "error",
            confirmButtonText: "OK",
          }).then(() => {
            // do nothing
          });
        } else {
          if (responseJson.length !== 0) {
            // Support both camelCase (new) and lowercase (legacy) field names
            const data = responseJson[0];
            const applicationStatus = data?.applicationStatus || data?.applicationstatus;
            const licenseNumber = data?.licenseNumber || data?.licensenumber;
            const contactEmail = data?.contactEmail || data?.contactemail;

            applicationStatus
              ? this.setState({
                  licenseStatus: applicationStatus,
                  license: licenseNumber,
                  isLicenseLoading: false,
                  userMail: contactEmail,
                })
              : this.setState({ isLicenseLoading: false });
          } else {
            this.setState({ isLicenseLoading: false });
          }
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  downloadCert = async () => {
    this.setState({ isDownloading: true });
    try {
      const apiUrl = `${baseUrl}/eservices/GetLicenseFile?timestamp=${Date.now()}`;
      const payload = {
        id: this.state.regNumber,
        nameOfCompany: this.state.orgName,
        regNumber: this.state.license,
        validTillDate: "31 December 2023",
      };

      const headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
        Pragma: "no-cache",
        Expires: "0",
      };
      const response = await axios.post(apiUrl, payload, {
        responseType: "blob",
        headers: headers,
      });

      let url = window.URL.createObjectURL(response.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "license.pdf";
      this.setState({ licenseCertificateFile: url });
      this.setState({ isDownloading: false });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //DOWNLOAD REGISTRATION CERT
  downloadRegCert = async () => {
    this.setState({ isDownloading: true });
    let date = moment(this.state.registrationDate).format("D MMMM YYYY ");
    try {
      const apiUrl = `${baseUrl}/eservices/GetCertificateFile?timestamp=${Date.now()}`;
      const payload = {
        cfsnNo: this.state.regNumber,
        dateOfRegistration: date,
        id: this.state.regNumber,
        nameOfCompany: `${
          this?.state?.title?.charAt(0).toUpperCase() +
          this?.state?.title?.slice(1)
        } ${this.state.surname} ${this.state.othernames}`,
      };

      const headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
        Pragma: "no-cache",
        Expires: "0",
      };
      const response = await axios.post(apiUrl, payload, {
        responseType: "blob",
        headers: headers,
      });
      let url = window.URL.createObjectURL(response.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "certificate.pdf";
      this.setState({ regCertificateFile: url });
      this.setState({ isDownloading: false });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  downloadLicenseCert = async () => {
    this.setState({ isDownloading: true });
    try {
      if (this.state.licenseData && this.state.licenseData.licenseCertificate) {
        // Fetch the license certificate image
        const response = await axios.get(
          this.state.licenseData.licenseCertificate,
          {
            responseType: "blob",
          }
        );

        // Create a blob URL from the response data
        const imageUrl = window.URL.createObjectURL(response.data);

        // Show SweetAlert2 popup with the image and download option
        Swal.fire({
          title: "License Certificate",
          imageUrl: imageUrl,
          imageAlt: "License Certificate",
          showCancelButton: true,
          confirmButtonText: "Download",
          cancelButtonText: "Close",
          width: "80%",
          customClass: {
            image: "img-fluid", // Make image responsive
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Create and trigger download
            const a = document.createElement("a");
            a.href = imageUrl;
            a.download = "license_certificate.png";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
          // Clean up the blob URL
          window.URL.revokeObjectURL(imageUrl);
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to load certificate. Please try again.",
        icon: "error",
      });
    } finally {
      this.setState({ isDownloading: false });
    }
  };

  // Handler function that actually triggers the payment
  handleLicensePayment = async () => {
    if (this.state.isPayingForLicense) return;

    this.setState({ isPayingForLicense: true });

    await makeLicensePayment(
      this.state.retrievedLicenseInfo.licenseId,
      this.state.retrievedLicenseInfo.rrr
    );

    this.setState({ isPayingForLicense: false });
  };

  // Returns a button element for rendering in certain places
  makePaymentReponse = () => {
    return (
      <button
        disabled={this.state.isPayingForLicense}
        onClick={this.handleLicensePayment}
        className="btn btn-danger m-0 p-1 px-3"
      >
        {this.state.isPayingForLicense && (
          <Spinner className="me-2" animation="grow" role="status" size="sm">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
        Pay for license
      </button>
    );
  };

  getUserDetails = async () => {
    const self = this;
    this.setState({ isUserInfoLoading: true });
    let obj = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await fetch(
      `${baseUrl}/v2/dashboard/user/${localStorage.getItem("userid")}`,
      obj
    )
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status === 401) {
          Swal.fire({
            title: "Session Expired",
            text: "Session expired. Please login",
            icon: "error",
            confirmButtonText: "OK",
          }).then(() => {
            this.props.history.push("/login");
          });
        } else {
          const licenseInformation = responseJson.licenseInformation;
          const registrationInformation = responseJson.registrationInformation;
          const userInformation = responseJson.userInformation;

          this.setState({
            regNumber: registrationInformation.csfnNumber,
            regStatus: registrationInformation.applicationStatus,
            regOfficialRemarks: registrationInformation.officialRemarks || "",
            certificateIssued: registrationInformation.certificateIssued === true,
            hasRegistrationCertificate: registrationInformation.hasRegistrationCertificate === true,
            license: licenseInformation.licenseNumber,
            paymentStatus: licenseInformation.paymentStatus,
            licenseStatus: licenseInformation.applicationStatus,
            hasLicenseApplication: licenseInformation.hasLicenseApplication,
            licenseExpired: licenseInformation.expired === true,
            licenseExpDateFromInfo: licenseInformation.expiryDate || null,
            hasLicenseCertificateFromInfo: !!licenseInformation.licenseCertificate,
            image: userInformation.userImage,
            fullName: userInformation.fullName,
            isUserInfoLoading: false,

            // the author decided to use local storage to send data
            // across the application while forgetting that function
            // parameters exist attempting to remedy by storing
            // necessary payment information in this state instead.
            retrievedLicenseInfo: {
              licenseId: licenseInformation.licenseId,
              rrr: licenseInformation.rrr,
            },
          });

          self.setState();

          if (licenseInformation.licenseId) {
            localStorage.setItem("licenseId", licenseInformation.licenseId);
            localStorage.setItem("rrr", licenseInformation.rrr);
          }
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  getLicenseRegistration = async () => {
    const url = `${baseUrl}/License/getlicenseByUserID/${localStorage.getItem(
      "userid"
    )}`;
    this.setState({ isLoading: true });
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(async (res) => {
        const resp = await res.json();
        return resp;
      })
      .then((res) => {
        res.map((item) => {
          const recId = item.recId || item.recid;
          this.setState({ recId: recId });
          this.getLicenseDetails(recId);
          // eslint-disable-next-line array-callback-return
          return;
        });
        if (res.status === 401) {
          Swal.fire({
            title: "Session Expired",
            text: "Session expired. Please login",
            icon: "error",
            confirmButtonText: "OK",
          }).then(() => {
            // do nothing
          });
        } else {
          this.setState({ data: res, loading: false });
        }
      })
      .catch((error) => {
        this.setState({ error: true, loading: false });
      });
  };

  getLicenseDetails = (recid) => {
    const licenseId = recid || this.state.recId;
    if (!licenseId) {
      return;
    }
    const url = `${baseUrl}/v2/license/${licenseId}`;
    this.setState({ isLoading: true });

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then(async (response) => {
        const newData = await response.json();

        // Check if we should update the license data
        const shouldUpdate =
          // Update if current licenseData is null
          !this.state.licenseData ||
          // Or if new data has a more recent licenseDate
          (newData.licenseDate &&
            (!this.state.licenseData.licenseDate ||
              new Date(newData.licenseDate) >
                new Date(this.state.licenseData.licenseDate)));

        if (shouldUpdate) {
          // Check if license has already expired
          const isExpired =
            newData.licenseExpDate &&
            new Date(newData.licenseExpDate) < new Date();

          this.setState({
            isLoading: false,
            licenseData: newData,
            showRenewalNotification:
              !isExpired &&
              checkLicenseRenewalNeeded(
                newData.licenseExpDate,
                newData.applicationStatus
              ),
            licenseExpired: isExpired,
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        this.setState({ error: true, loading: false });
        console.error("Error fetching license details:", error);
      });
  };

  // Check ALL non-complete payments with Remita
  checkAllPendingPayments = async () => {
    this.setState({ isVerifyingPayments: true });

    try {
      // Fetch all user payments
      const response = await fetch(
        `${baseUrl}/v2/user/payments?size=50`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        }
      );

      if (!response.ok) {
        this.setState({ isVerifyingPayments: false });
        return;
      }

      const data = await response.json();
      const payments = data.content || [];

      // Check ALL payments that are NOT completed
      const paymentsToCheck = payments.filter(p => {
        const status = (p.statusCode || p.status || '').toLowerCase();
        const isComplete = this.COMPLETE_CODES.some(code => status.includes(code));
        return !isComplete && p.rrr; // Has RRR and is not complete
      });

      if (paymentsToCheck.length === 0) {
        this.setState({ isVerifyingPayments: false });
        return;
      }

      // Check each payment with Remita
      const completedPayments = [];

      for (const payment of paymentsToCheck) {
        if (!payment.rrr) continue;

        try {
          const statusResponse = await fetch(
            `${baseUrl}/v2/remita/checkRRRStatus/${payment.rrr}`,
            {
              method: 'PUT',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
              },
            }
          );

          const result = await statusResponse.json();

          if (result.paymentStatus === 'complete') {
            completedPayments.push({
              ...payment,
              description: this.getPaymentDescription(payment)
            });
          }
        } catch (error) {
          console.warn(`Failed to check payment ${payment.rrr}:`, error);
        }
      }

      // Notify user of any completed payments
      if (completedPayments.length > 0) {
        this.notifyPaymentsCompleted(completedPayments);
      }
    } catch (error) {
      console.warn('Payment verification failed:', error);
    } finally {
      this.setState({ isVerifyingPayments: false });
    }
  };

  // Get human-readable description for payment type
  getPaymentDescription = (payment) => {
    const formType = (payment.formType || '').toLowerCase();
    if (formType.includes('registration')) return 'Registration';
    if (formType.includes('renewal')) return 'License Renewal';
    if (formType.includes('license')) return 'License';
    return payment.description || 'Payment';
  };

  // Show notification for completed payments
  notifyPaymentsCompleted = (payments) => {
    if (payments.length === 1) {
      Swal.fire({
        title: 'Payment Confirmed!',
        text: `Your ${payments[0].description} payment has been verified and confirmed.`,
        icon: 'success',
        timer: 4000,
        showConfirmButton: true,
      });
    } else {
      const paymentList = payments.map(p => `• ${p.description}`).join('<br/>');
      Swal.fire({
        title: 'Payments Confirmed!',
        html: `<p>The following payments have been verified:</p><div style="text-align:left">${paymentList}</div>`,
        icon: 'success',
        timer: 5000,
        showConfirmButton: true,
      });
    }
  };

  componentDidMount() {
    this.getLicenseNumber();
    this.getLicenseRegistration();

    // Load user details first, then verify payments in background
    this.getUserDetails().then(() => {
      // Check payments in background - StatusBanner shows loading indicator
      this.checkAllPendingPayments().then(() => {
        // Refresh user details to get updated statuses after verification
        this.getUserDetails();
      });
    });
  }

  render() {
    const {
      regNumber,
      regOfficialRemarks,
      image,
      fullName,
      license,
      isLicenseLoading,
      regStatus,
      hasLicenseApplication,
      isUserInfoLoading,
      licenseStatus,
      paymentStatus,
      licenseExpired,
      licenseData,
      applicationDate,
    } = this.state;

    // Show loading spinner while initial data loads
    if (isUserInfoLoading) {
      return (
        <div className="dashboard-container">
          <Sidebar />
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <Spinner animation="border" variant="primary" />
          </div>
        </div>
      );
    }

    // Get status variant for registration status card
    const regStatusLower = regStatus?.toLowerCase();
    const getRegStatusVariant = () => {
      if (regStatusLower === 'approved') {
        return this.state.certificateIssued ? 'success' : 'warning';
      }
      if (regStatusLower === 'rejected') return 'danger';
      if (regStatusLower === 'returned') return 'warning';
      if (regStatusLower === 'submitted') return 'info';
      if (regStatusLower === 'pending') return 'secondary';
      return 'primary';
    };

    const getRegStatusDisplay = () => {
      if (regStatusLower === 'approved') {
        if (!this.state.certificateIssued) return 'Approved - Awaiting Certificate';
        if (!this.state.hasRegistrationCertificate) return 'Approved - Physical Certificate';
        return 'Approved';
      }
      if (regStatusLower === 'rejected') return 'Rejected';
      if (regStatusLower === 'returned') return 'Corrections Required';
      if (regStatusLower === 'submitted') return 'Under Review';
      if (regStatusLower === 'pending') return 'Pending Payment';
      return regStatus || 'N/A';
    };

    return (
      <div className="dashboard-container">
        <Sidebar />

        <div className="dashboard-main">
          {/* Mobile/Desktop Header */}
          <DashboardHeader
            fullName={fullName}
            image={image}
          />

          <div className="dashboard-content">
            {/* Welcome Section (Desktop only) */}
            <div className="welcome-section">
              <h2>Welcome back, {fullName.split(' ')[0] || 'User'}</h2>
              <p>Here's an overview of your NiCFoST account</p>
            </div>

            {/* Status Banner */}
            <StatusBanner
              licenseStatus={licenseStatus}
              paymentStatus={paymentStatus}
              licenseExpired={licenseExpired}
              licenseExpDate={licenseData?.licenseExpDate || this.state.licenseExpDateFromInfo}
              licenseId={licenseData?.licenseId || this.state.retrievedLicenseInfo?.licenseId}
              hasLicenseApplication={hasLicenseApplication}
              hasLicenseCertificate={
                licenseData
                  ? !!licenseData.licenseCertificate
                  : this.state.hasLicenseCertificateFromInfo
              }
              licenseOfficialRemarks={licenseData?.licenseRemarks || ""}
              onPayment={this.handleLicensePayment}
              regStatus={regStatus}
              regOfficialRemarks={regOfficialRemarks}
              isVerifyingPayments={this.state.isVerifyingPayments}
              certificateIssued={this.state.certificateIssued}
              hasRegistrationCertificate={this.state.hasRegistrationCertificate}
            />

            {/* Stat Cards */}
            <div className="stat-cards">
              <StatCard
                icon="badge"
                label="CFSN Number"
                value={regNumber}
                variant="primary"
                loading={isLicenseLoading}
              />
              <StatCard
                icon="card_membership"
                label="License Number"
                value={license?.length ? license : 'Not issued'}
                variant="success"
                loading={isLicenseLoading}
              />
              <StatCard
                icon="verified"
                label="Registration Status"
                value={getRegStatusDisplay()}
                variant={getRegStatusVariant()}
                valueVariant={getRegStatusVariant()}
                loading={isLicenseLoading}
              />
            </div>

            {/* Quick Actions */}
            <QuickActions
              regStatus={regStatus}
              licenseStatus={licenseStatus}
              hasLicenseCertificate={!!licenseData?.licenseCertificate}
              licenseId={licenseData?.licenseId}
              onDownloadCertificate={() => this.downloadLicenseCert()}
              onPayment={this.handleLicensePayment}
              paymentStatus={paymentStatus}
            />

            {/* License Timeline - Only show during application process */}
            {hasLicenseApplication && licenseStatus?.toLowerCase() === 'pending' && (
              <LicenseTimeline
                paymentStatus={paymentStatus}
                applicationDate={licenseData?.applicationDate || applicationDate}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withSidebar(Dashboard);
